<template>
  <div class="two-auth-box">
    <div class="box-title">
      <div class="text">Bảo mật 2 lớp</div>
    </div>
    <div class="content-box">
      <b-row>
        <b-col
          md="6"
          lg="5"
          cols="12"
          class="text-center mb-4"
          v-if="!UserAuth.enable"
        >
          <img
            :src="UserAuth.qr"
            alt=""
            style="filter: drop-shadow(2px 4px 6px #ccc)"
            class="mx-auto"
          />
        </b-col>
        <b-col md="6" lg="7" cols="12" class="mx-auto">
          <div class="form-group" v-if="!UserAuth.enable">
            <label for="">Mã bí mật</label>
            <div class="auth-copy">
              <b-input-group class="">
                <template #prepend>
                  <b-input-group-text>
                    <b-button
                      v-clipboard:copy="UserAuth.secret"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError"
                    >
                      Sao Chép
                    </b-button>
                  </b-input-group-text>
                </template>
                <b-form-input
                  type="text"
                  required
                  v-model="UserAuth.secret"
                  readonly
                ></b-form-input>
              </b-input-group>
            </div>
          </div>
          <div class="form-group">
            <label for="">
              Nhập mã xác minh được cung cấp bởi ứng dụng xác thực của bạn
            </label>
            <div class="auth-copy">
              <b-form-input
                type="text"
                required
                v-model="authcode"
                placeholder="Nhập mã tại đây"
              ></b-form-input>
            </div>
          </div>
          <div class="form-group d-flex justify-content-center">
            <b-button
              class="mx-auto mt-3"
              variant="primary"
              @click="onUpdateAuth"
            >
              {{ UserAuth.enable ? "Tắt" : "Bật" }} bảo mật 2 lớp
            </b-button>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      authcode: "",
    };
  },
  computed: {
    ...mapGetters({
      UserAuth: "user/UserAuth",
    }),
  },
  methods: {
    onCopy() {
      this.$toastr.s("Sao chép thành công");
    },
    onError() {
      this.$toastr.e("Sao chép thất bại, vui lòng thử lại sau vài giây");
    },
    onUpdateAuth() {
      this.$store.dispatch("user/req_postAuth", {
        authCode: this.authcode,
        secret: this.UserAuth.secret,
      });
      this.authcode = "";
    },
  },
  created() {
    this.$store.dispatch("user/req_getAuth");
  },
};
</script>

<style lang="scss">
.two-auth-box {
  width: 100%;
  min-height: 50px;
  border-radius: 10px;
  position: relative;
  margin-bottom: 1.25rem;
  .box-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 40px;
    padding: 0 1.25rem;
    background-color: #ffff;
    border-radius: 10px 10px 10px 10px;
    box-shadow: 2px 3px 10px 0px rgba(0, 0, 0, 0.305);
    .text {
      color: #000;
      font-weight: 600;
      font-size: 20px;
      text-transform: capitalize;
      .text-warning {
        font-size: clamp(15px, 2vw, 16px);
      }
    }
    .icon {
      cursor: pointer;
      img {
        height: 20px;
        width: auto;
      }
      &.active {
        transform: rotate(180deg);
      }
    }
  }
  .content-box {
    padding: 1.25rem;
    img {
      max-width: 100%;
    }
    .form-group {
      margin-bottom: 20px;
      label {
        font-size: 17px;
        color: #ffff;
        font-weight: 600;
        margin-bottom: 5px;
      }
      .auth-copy {
        margin-top: 5px;
        background: #556de669;
        border-radius: 5px;
        .input-group-text {
          padding: 0;
          border: 0;
          button {
            width: 100px;
            height: 40px;
            padding: 0;
            background: #556ee6;
            border: 0;
            outline: none;
            border-radius: 5px;
            box-shadow: 0px 0px 5px 1px #0000009e;
            font-weight: 600;
            color: #fff !important;
          }
        }
        input {
          height: 40px;
          border: 0;
          background: #fff;
          color: #000;
          font-weight: 600;
          &::placeholder {
            color: #fff;
            opacity: 0.8;
          }
          &:hover,
          &:focus,
          &:focus-visible {
            outline: none;
            box-shadow: none;
            border: 0;
          }
        }
      }
    }
  }
}
</style>
